import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../component/useAuth';

const ProtectedRoute = ({ element, role }) => {
  const { isAuthenticated, userType } = useAuth();

  console.log("userType",userType);
  console.log("role",role);

  if (isAuthenticated === null) {
   
    return null;
  }

 
  if (isAuthenticated) {
    if (userType === role) {
      return element;
    }
    else if(userType === 4){
      return element
    }
    return <Navigate to="/" />;
  } else {
    return <Navigate to="/" />;
  }
};

export default ProtectedRoute;
